import { AxiosRequestConfig } from 'axios'
import { FeatureCollection, Geometry } from 'geojson'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { RegionProperties } from '@/types/regions'

export interface Region {
  name: string
  region_id: number
  project_id: number
  geojson?: FeatureCollection<Geometry, RegionProperties>
  col_name?: string
}

export type GetRegionByIdRequestResponse = Region | null

export async function getRegionById(id: number, options?: AxiosRequestConfig) {
  const { data } = await companiesApi.get<Region | undefined>(
    apiRoutes.getRegionById(id),
    options,
  )

  if (!data) {
    return null
  }

  return data
}
